"use strict";
/* eslint-disable import/prefer-default-export, camelcase */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockAssignedContentData = exports.mockPrimaryCourseMetadata = exports.mockPrimaryCourseData = void 0;
exports.mockPrimaryCourseData = {
    data: {
        course: {
            uuid: '5f208a3e-e1c0-41d6-94db-a29febed3c8e',
            display_name: 'Java',
            completion_percentage: 56.52,
            icon_url: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customCourses/customCourse-10.svg',
            score: 200,
            total_lessons: 20,
            completed_lessons: 3,
        },
        lessons: [
            {
                uuid: '6167f23fc27d3db2e6952a04',
                display_name: 'SQL Injection',
                status: 'completed',
                url: 'courses/java/lessons/sql_injection',
                active_on_lean: true,
            },
            {
                uuid: '6167f2408df887dad076a616',
                display_name: 'XXE Processing',
                status: 'completed',
                url: 'courses/java/lessons/xxe_processing',
                active_on_lean: true,
            },
            {
                uuid: '6167f23bc27d3d92df9529f5',
                display_name: 'Command Injection',
                status: 'completed',
                url: 'courses/java/lessons/command_injection',
                active_on_lean: true,
            },
            {
                uuid: '6167f23f8df88728e476a610',
                display_name: 'Session Fixation',
                status: 'completed',
                url: 'courses/java/lessons/session_fixation',
                active_on_lean: false,
            },
            {
                uuid: '6167f2408df8872a0e76a613',
                display_name: 'Use of Insufficiently Random Values',
                status: 'completed',
                url: 'courses/java/lessons/use_of_insufficiently_random_values',
                active_on_lean: false,
            },
            {
                uuid: '6167f23ec27d3d4f8d952a01',
                display_name: 'Reflected XSS',
                status: 'completed',
                url: 'courses/java/lessons/reflected_xss',
                active_on_lean: false,
            },
            {
                uuid: '6167f23f2479f1d557d557e3',
                display_name: 'Stored (Persistent) XSS',
                status: 'completed',
                url: 'courses/java/lessons/stored_persistent_xss',
                active_on_lean: false,
            },
            {
                uuid: '6167f23c8df887633876a607',
                display_name: 'DOM XSS',
                status: 'completed',
                url: 'courses/java/lessons/dom_xss',
                active_on_lean: true,
            },
            {
                uuid: '6167f23c2479f12101d557d7',
                display_name: 'Directory (Path) Traversal',
                status: 'completed',
                url: 'courses/java/lessons/directory_path_traversal',
                active_on_lean: false,
            },
            {
                uuid: '6167f23e8df887fa6176a60d',
                display_name: 'Privileged Interface Exposure',
                status: 'completed',
                url: 'courses/java/lessons/privileged_interface_exposure',
                active_on_lean: false,
            },
            {
                uuid: '6167f23e2479f15231d557dd',
                display_name: 'Leftover Debug Code',
                status: 'completed',
                url: 'courses/java/lessons/leftover_debug_code',
                active_on_lean: false,
            },
            {
                uuid: '6167f23a2479f14e4cd557d1',
                display_name: 'Authentication Credentials In URL',
                status: 'completed',
                url: 'courses/java/lessons/authentication_credentials_in_url',
                active_on_lean: false,
            },
            {
                uuid: '6167f23f2479f1ecb9d557e0',
                display_name: 'Session Exposure Within URL',
                status: 'completed',
                url: 'courses/java/lessons/session_exposure_within_url',
                active_on_lean: false,
            },
            {
                uuid: '6167f240c27d3d5d85952a07',
                display_name: 'User Enumeration',
                status: 'not_started',
                url: 'courses/java/lessons/user_enumeration',
                active_on_lean: false,
            },
            {
                uuid: '6167f23dc27d3d218a9529fb',
                display_name: 'Horizontal Privilege Escalation',
                status: 'not_started',
                url: 'courses/java/lessons/horizontal_privilege_escalation',
                active_on_lean: false,
            },
            {
                uuid: '6167f2402479f1f94dd557e6',
                display_name: 'Vertical Privilege Escalation',
                status: 'not_started',
                url: 'courses/java/lessons/vertical_privilege_escalation',
                active_on_lean: false,
            },
            {
                uuid: '6167f23cc27d3db1409529f8',
                display_name: 'Cross Site Request Forgery (POST)',
                status: 'not_started',
                url: 'courses/java/lessons/cross_site_request_forgery_post',
                active_on_lean: false,
            },
            {
                uuid: '6167f23c8df8871ae076a604',
                display_name: 'Cross Site Request Forgery (GET)',
                status: 'not_started',
                url: 'courses/java/lessons/cross_site_request_forgery_get',
                active_on_lean: false,
            },
            {
                uuid: '6167f23b8df887b6da76a601',
                display_name: 'Click Jacking',
                status: 'not_started',
                url: 'courses/java/lessons/click_jacking',
                active_on_lean: false,
            },
            {
                uuid: '6167f23ec27d3d9d679529fe',
                display_name: 'Insecure URL Redirect',
                status: 'not_started',
                url: 'courses/java/lessons/insecure_url_redirect',
                active_on_lean: false,
            },
            {
                uuid: '6167f23d8df887783976a60a',
                display_name: 'Insecure TLS Validation',
                status: 'not_started',
                url: 'courses/java/lessons/insecure_tls_validation',
                active_on_lean: false,
            },
            {
                uuid: '6167f23d2479f10114d557da',
                display_name: 'Insecure Object Deserialization',
                status: 'not_started',
                url: 'courses/java/lessons/insecure_object_deserialization',
                active_on_lean: false,
            },
            {
                uuid: '6167f23b2479f1f9d0d557d4',
                display_name: 'Vulnerable and Outdated Components',
                status: 'not_started',
                url: 'courses/java/lessons/components_with_known_vulnerabilities',
                active_on_lean: false,
            },
        ],
    },
};
exports.mockPrimaryCourseMetadata = {
    data: {
        uuid: '5f208a3e-e1c0-41d6-94db-a29febed3c8e',
        display_name: 'Java',
        completion_percentage: 56.52,
        icon_url: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customCourses/customCourse-10.svg',
        score: 200,
        total_lessons: 20,
        completed_lessons: 3,
    },
};
exports.mockAssignedContentData = {
    data: {
        primary_course: {
            uuid: '6167f23b2479f1f9d0d557d4',
            course_display_name: 'Vulnerable and Outdated Components',
            score: 600,
            assigned_on: '2021-03-24 16:48:05.591',
            name: 'vul',
            completion_percentage: 90,
            icon_url: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
        },
        assigned_lessons: {
            total: 4,
            completed: 5,
            completion_percentage: 25.11111,
            lessons: [
                {
                    uuid: '6167f23b2479f1f9d0d557d4',
                    display_name: 'Insecure Object Deserialization',
                    url: 'courses/java/lessons/components_with_known_vulnerabilities',
                    score: 600,
                    assigned_at: '2021-03-24 16:48:05.591',
                    status: 'completed',
                },
                {
                    uuid: '6167f23b2479f1f9d0d557d4',
                    display_name: 'Insecure TLS Validation',
                    url: 'courses/java/lessons/components_with_known_vulnerabilities',
                    score: 600,
                    assigned_at: '2021-03-24 16:48:05.591',
                    status: 'completed',
                    icon_url: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
                },
                {
                    uuid: '6167f23b2479f1f9d0d557d4',
                    display_name: 'Insecure URL Redirect',
                    url: 'courses/java/lessons/components_with_known_vulnerabilities',
                    score: 600,
                    assigned_at: '2021-03-24 16:48:05.591',
                    status: 'not_started',
                    icon_url: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
                },
                {
                    uuid: '6167f23b2479f1f9d0d557d4',
                    display_name: 'Click Jacking',
                    url: 'courses/java/lessons/components_with_known_vulnerabilities',
                    score: 600,
                    assigned_at: '2021-03-24 16:48:05.591',
                    status: 'not_started',
                    icon_url: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
                },
            ],
        },
        assessments: {
            total: 2,
            completed: 2,
            completion_percentage: 10,
            assessments: [
                {
                    uuid: '6167f23b2479f1f9d0d557d4',
                    name: 'Java Advanced Pro',
                    url: 'courses/java/lessons/components_with_known_vulnerabilities',
                    score: 600,
                    end_date: '2021-03-24 16:48:05.591',
                    status: 'completed',
                },
                {
                    uuid: '6167f23b2479f1f9d0d557d4',
                    name: 'Java Advanced Pro',
                    url: 'courses/java/lessons/components_with_known_vulnerabilities',
                    score: 600,
                    end_date: '2021-03-24 16:48:05.591',
                    status: 'not_started',
                },
            ],
        },
    },
};
